var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-block d-sm-block d-md-none"},[_c('BannerTopMobile',{attrs:{"image":`${_vm.url_banners_mobile}/images/mobile/banner_home.jpg`}})],1),_c('div',{staticClass:"d-flex justify-content-center"},[_c('RegisterForm',{attrs:{"redirect":_vm.redirect}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }